module.exports = "<p>\n  table-alert works!\n</p>\n"